import styled from "styled-components";
export const RollCallStyle = styled.div`
  .inputs {
    background-color: ${({ theme }) => theme.box};
    padding: 10px;
    box-shadow: ${({ theme }) => theme.shadow};
    border-radius: 15px;
  }
  .nav-tabs {
    display: flex;
    justify-content: space-evenly;
    border: none;
    .nav-item {
      button {
        color: ${({ theme }) => theme.text};

        border-radius: 5px;
        border: none;
      }
      button.active {
        background-color: ${({ theme }) => theme.box};
      }
    }
  }
  .tab-content {
    .tab-pane {
      border: none !important;

      .css-1jknvbe-menu {
        background-color: ${({ theme }) => theme.body};
        color: ${({ theme }) => theme.text};
      }
    }
  }
  .leave-req {
    background-color: ${({ theme }) => theme.box};
    color: ${({ theme }) => theme.text};
    border-radius: 8px;
    box-shadow: ${({ theme }) => theme.shadow};
    .header {
      background-color: ${({ theme }) => theme.body};
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      padding: 10px;
    }
    .req-body {
      padding: 10px;
    }
  }
`;
